import api from './api.js';

const adminApi = {
  // Generic methods for direct API access
  get: (url, config) => api.get(url, config),
  post: (url, data, config) => api.post(url, data, config),
  put: (url, data, config) => api.put(url, data, config),
  delete: (url, config) => api.delete(url, config),

  // Get all site goals
  getGoals: () => api.get('/admin/goals'),

  // Get a specific site goal
  getGoal: (id) => api.get(`/admin/goals/${id}`),

  // Create a new site goal
  createGoal: (goalData) => api.post('/admin/goals', goalData),

  // Update a site goal
  updateGoal: (id, goalData) => api.put(`/admin/goals/${id}`, goalData),

  // Delete a site goal
  deleteGoal: (id) => api.delete(`/admin/goals/${id}`),

  // Update all goal current values
  updateGoalValues: () => api.post('/admin/goals/update-current-values'),

  // Get admin dashboard
  getDashboard: () => api.get('/admin/dashboard'),

  // User Management
  getUsers: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/admin/users${queryString ? `?${queryString}` : ''}`);
  },

  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),

  resetUserPassword: (userId, newPassword) => api.post(`/admin/users/${userId}/reset-password`, { newPassword }),

  // Reading Reports Management
  getReports: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/admin/reports${queryString ? `?${queryString}` : ''}`);
  },

  getReportsStats: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/admin/reports/stats${queryString ? `?${queryString}` : ''}`);
  },

  exportReports: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/admin/reports/export${queryString ? `?${queryString}` : ''}`, {
      responseType: 'blob'
    });
  },

  resetAllReports: () => api.delete('/admin/reports/reset', {
    data: { confirmation: 'DELETE_ALL_REPORTS' }
  }),

  // Clean up all fake data (DANGER!)
  cleanupFakeData: () => api.post('/admin/cleanup-fake-data', {
    confirmation: 'DELETE_ALL_FAKE_DATA'
  }),

  // New comprehensive reset for all progress and points
  resetAllProgress: (confirmationText) => api.delete('/reports/admin/reset-all-progress', {
    data: { confirmationText }
  }),

  // User and points management
  getUserDetails: (userId) => api.get(`/admin/users/${userId}/details`),
  getReaderPointsHistory: (readerId, params = {}) => api.get(`/admin/readers/${readerId}/points-history`, { params }),
  getPointsSummary: () => api.get('/admin/points-summary')
};

export default adminApi;
